import { InitialConfigType } from '@lexical/react/LexicalComposer';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';

export interface UpdateconfigPluginProps {
  config?: Partial<InitialConfigType>;
}

export function UpdateConfigPlugin({ config }: UpdateconfigPluginProps) {
  const [editor] = useLexicalComposerContext();
  useEffect(() => {
    editor.setEditable(config?.editable ?? true);
  }, [editor, config?.editable]);

  return null;
}
